<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
    >
      <v-card-title>
        Link pratica non più valido
      </v-card-title>
    </v-toolbar>
   
    <v-card-text class="subtitle-1">
      Il link per accedere alla pratica non è più valido.
      <br>

    </v-card-text>
   
 
  </v-card>
</template>
<script>
 import { mapGetters } from "vuex";
export default {
  data () {
    return {
    
    }
  },
  computed: {
  },
  methods: {
 
  }

}
</script>